import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposerLoadingOverlay = () => {
  return /*#__PURE__*/_jsx(LoadingOverlay, {
    contextual: true,
    showLabel: true,
    layout: "centered"
  });
};
ComposerLoadingOverlay.displayName = 'ComposerLoadingOverlay';
export default ComposerLoadingOverlay;